/**
 * Границы адаптивной сетки в пикселях.
 *
 * @type {{ xs: number, sm: number, md: number, lg: number }}
 */
export const breakpoints = {
  xs: 600,
  sm: 960,
  md: 1280,
  lg: 1920
}
